export default "<p>stock-dash-board works!</p>\n";